<script>
export default {
  name: 'NapkinsItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSelected: false,
    }
  },
  computed: {
    updateNapkinsItem() {
      return  Object.assign({}, this.item, {
        paid_unit_price: this.item.value,
        quantity: 1,
        include: this.isSelected,
        units: 1,
        product_compensation_type: this.item.type,
      })
    }
  },
  watch: {
    isSelected() {
      const napkinsItem = this.updateNapkinsItem
      this.$emit('productUpdate', napkinsItem)
    },
  },
}
</script>

<template>
  <div 
    v-if="item.show" 
    :class="$style.container">
    <div :class="$style.container__product">
      <div :class="$style.container__product__image">
        <img 
          :src="item.image" 
          width="69" 
          height="69" 
          loading="lazy" >
      </div>
      <div :class="$style.container__product__info">
        {{ item.name }}
      </div>
    </div>
    <div :class="$style.container__productActions">
      <v-checkbox v-model="isSelected"/>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  justify-content: space-between;
  padding: 1rem;

  &__product {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;

    &__image {
      width: 69px;
      height: 69px;
      border-radius: 10px;
      object-fit: cover;
    }

    &__info {
      font-weight: bold;
      padding: 1rem .8rem;
      font-size: 1.1rem;
      max-width: 180px;
      height: 100%;
      text-transform: capitalize;
      text-align: left;
      overflow: hidden;
      word-wrap: break-word;
    }
  }

  &__productActions {
    display: flex;
    align-items: flex-start;
  }
}
</style>
